import React from 'react';
import TableOrdinary from './TableOrdinary';
import TableCustomize from './TableCustomize';
import { useTranslation } from 'react-i18next';
import getSteelMakerName from '../../../utils/getSteelMakerName';
import getBusinessTypeName from '../../../utils/getBusinessTypeName';
import getSteelCategoryName from '../../../utils/getSteelCategoryName';
import type { BusinessType, Language, SteelCategory, SteelMaker } from '../../../types/common';
import type { OptionsType } from '../../../types/options';
import type { ConditionWithDetailType } from '../../../types/condition';

interface TableReviewProps {
  organizationName: string;
  applicantName: string;
  approverName: string;
  confirmCondition: ConditionWithDetailType | undefined;
  steelMaker: OptionsType<SteelMaker>[];
  businessType: OptionsType<BusinessType>[];
  steelCategory: OptionsType<SteelCategory>[];
  language: Language;
}

const TableReview = ({ organizationName, applicantName, approverName, confirmCondition, steelMaker, businessType, steelCategory, language }: TableReviewProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <p className="mb-1">{t('approval.information')}</p>
      <table className="table table-approval-info mb-4">
        <tbody>
          <tr>
            <th>{t('organization.organization')}</th>
            <td colSpan={5}>{organizationName}</td>
          </tr>
          <tr>
            <th style={{ width: '16.6%' }}>{t('steelMaker')}</th>
            <td style={{ width: '16.6%' }}>{getSteelMakerName(confirmCondition.steelMaker, steelMaker, language)}</td>
            <th style={{ width: '16.6%' }}>{t('businessType')}</th>
            <td style={{ width: '16.6%' }}>{getBusinessTypeName(confirmCondition.businessType, businessType, language)}</td>
            <th style={{ width: '16.6%' }}>{t('steerCategory')}</th>
            <td style={{ width: '16.6%' }}>{getSteelCategoryName(confirmCondition.steelCategory, steelCategory, language)}</td>
          </tr>
          <tr>
            <th>{t('approval.grid.requestor')}</th>
            <td colSpan={5}>{applicantName}</td>
          </tr>
          <tr>
            <th>{t('approval.grid.approver')}</th>
            <td colSpan={5}>{approverName}</td>
          </tr>
        </tbody>
      </table>
      {Array.isArray(confirmCondition?.detailOrdinary) && confirmCondition.detailOrdinary.length > 0 && (
        <TableOrdinary steelMaker={confirmCondition.steelMaker} businessType={confirmCondition.businessType} detailOrdinary={confirmCondition.detailOrdinary} />
      )}
      {Array.isArray(confirmCondition?.detailCustomize) && confirmCondition.detailCustomize.length > 0 && (
        <TableCustomize steelMaker={confirmCondition.steelMaker} businessType={confirmCondition.businessType} detailCustomize={confirmCondition.detailCustomize} />
      )}
    </>
  );
};

export default TableReview;
